<template>
  <div v-if="this.order">
    <div class="order-title">
      <h1>{{ $t("orderDetailsTitle", { orderId: order.id }) }}</h1>
      <p>
        {{
          $t("orderDescription") + " " + this.getDisplayDate(order.date) + " - "
        }}
        {{ order.total_amount_value | toCurrency }}
      </p>
    </div>
    <div class="options">
      <div class="left">
        <span class="status-background" :class="selectColorStatus(order.status)">{{ $t("orderStatus_" + order.status)
        }}</span>
      </div>
      <div class="right">
        <a @click="payOrder('')" class="notification-action padding-10" v-if="order.total_amount_value > 0 &&
          (order.status === 'P' || order.status === 'N')
          ">
          {{ $t("paymentButtonLabel") }}
        </a>
        <a @click="payOrder('later')" class="notification-action padding-10" v-if="order.total_amount_value > 0 &&
          (order.status === 'P' || order.status === 'N')
          ">
          {{ $t("ordersButtonLabel") }}
        </a>
        <a v-if="order.muorderid > 0" class="notification-action padding-10" @click="
          openAWB(
            'https://www.easymail.gr/index.php/web-tracking?UP' +
            order.muorderid
          )
          " target="_blank">
          <!-- <font-awesome-icon icon="truck" size="2x" /> -->
          {{ $t("ordersTableHeaderTrack") }}
          <!-- <img class= "track-trace-big" src="@/assets/images/tracktrace.png"  /> -->
        </a>
      </div>
    </div>

    <OrderDetailsSummary :order="this.order" :orderAddresses="this.orderAddresses" />

    <div class="container-alb">
      <div class="header-table">
        <div class="left">
          <h3>{{ $t("beneficiariesName") }}</h3>
          <img v-if="order.type !== 'REPL'" class="download" @click="downloadExcelOrderFile"
            src="@/assets/images/download.svg" />
          <!-- </export-excel> -->
        </div>
        <div class="right">
          <input type="text" v-model="search" :placeholder="$t('searchPlaceholder')" class="formedituser search-input" />
        </div>
      </div>
      <table id="test" cellpadding="10" cellspacing="0" width="95%" align="center">
        <tr>
          <th valign="middle">
            <strong>{{ $t("noCrtLabel") }}</strong>
          </th>
          <th @click="() => (sortBy = 'first_name')" valign="middle">
            <strong>{{
              orderType === "PAPER"
              ? $t("beneficiaryVoucherLabel")
              : (isOrderProductReward )
                ? $t("beneficiariesTableTextOnCard")
                : $t("beneficiariesTableSurname")
            }}</strong>&nbsp;
            <img src="@/assets/images/arrow-down-fill.svg" @click="sortBy === 'first_name' && changeReverse()" :style="sortBy === 'first_name' &&
                  reverse &&
                  'transform: rotate(180deg)'
                  " />
          </th>
          <th @click="() => (sortBy = 'last_name')" valign="middle" class="priority-2" v-if="orderType !== 'PAPER'">
            <strong>{{
              isOrderProductReward
              ? $t("beneficiariesTableDetails")
              : $t("beneficiariesTableName")
            }}</strong>&nbsp;
            <img src="@/assets/images/arrow-down-fill.svg" @click="sortBy === 'last_name' && changeReverse()" :style="sortBy === 'last_name' && reverse && 'transform: rotate(180deg)'
                " />
          </th>
          <th @click="() => (sortBy = 'from_source_id')" valign="middle" class="priority-3" v-if="orderType !== 'PAPER'">
            <strong>{{
              isOrderProductReward
              ? $t("beneficiariesTableAmount")
              : $t("beneficiariesTableCNP")
            }}</strong>&nbsp;
            <img src="@/assets/images/arrow-down-fill.svg" @click="sortBy === 'from_source_id' && changeReverse()" :style="sortBy === 'from_source_id' &&
                reverse &&
                'transform: rotate(180deg)'
                " />
          </th>
          <th @click="() => (sortBy = 'total_nominal_value')" valign="middle" class="priority-4"
            v-if="orderType !== 'PAPER' && !isOrderProductReward ">
            <strong>{{ $t("beneficiariesTableTicketValue") }}</strong>&nbsp;
            <img src="@/assets/images/arrow-down-fill.svg" @click="sortBy === 'total_nominal_value' && changeReverse()"
              :style="sortBy === 'total_nominal_value' &&
                reverse &&
                'transform: rotate(180deg)'
                " />
          </th>

          <th valign="middle" class="priority-2" v-if="orderType === 'PAPER'">
            <strong>{{ $t("noOfBookletLabel") }}</strong>
          </th>
          <th valign="middle" class="priority-2" v-if="orderType === 'PAPER'">
            <strong>{{ $t("noTicketsValue1Label1") }}</strong>
          </th>
          <th valign="middle" class="priority-2" v-if="orderType === 'PAPER'">
            <strong>{{ $t("amountVoucher1Label1") }}</strong>
          </th>
          <th valign="middle" class="priority-3" v-if="orderType === 'PAPER'">
            <strong>{{ $t("noTicketsValue2Label") }}</strong>
          </th>
          <th valign="middle" class="priority-3" v-if="orderType === 'PAPER'">
            <strong>{{ $t("amountVoucher2Label") }}</strong>
          </th>
          <th valign="middle" class="priority-4" v-if="orderType === 'PAPER'">
            <strong>{{ $t("noTicketsValue3Label") }}</strong>
          </th>
          <th valign="middle" class="priority-4" v-if="orderType === 'PAPER'">
            <strong>{{ $t("amountVoucher3Label") }}</strong>
          </th>
        </tr>
        <template v-for="(beneficiary, index) in filterBeneficiaries">
          <tr :key="index" class="trhover parent" :class="index % 2 === 0 && 'gri-cell'"
            @click="selectBeneficiaryMobile(index)">
            <td valign="middle">
              <a class="detailsOrderMobile priority-show-5 display-inline-block">
                <font-awesome-icon icon="minus-circle" v-if="detailsMobile && beneficiary === beneficiarySelectedMobile
                  " />
                <font-awesome-icon icon="plus-circle" v-else />&nbsp;&nbsp;
              </a>
              <span class="crt">{{ index + 1 }}</span>
            </td>
            <td valign="middle">{{ beneficiary.first_name }}</td>
            <td valign="middle" class="priority-2" v-if="orderType !== 'PAPER'">
              {{ beneficiary.last_name }}
            </td>
            <td valign="middle" class="priority-3" v-if="orderType !== 'PAPER'">
              <span v-if="isOrderProductReward">
                {{ beneficiary.from_source_id | toCurrency }}
              </span>
              <span v-else>
                {{ beneficiary.from_source_id }}
              </span>
            </td>
            <td valign="middle" class="priority-4" v-if="orderType !== 'PAPER' && !isOrderProductReward ">
              <div>
                {{ beneficiary.total_nominal_value | toCurrency }}
              </div>
            </td>
            <td valign="middle" class="priority-2" v-if="orderType === 'PAPER'">
              {{ beneficiary.booklets }}
            </td>
            <td valign="middle" class="priority-2" v-if="orderType === 'PAPER'">
              {{ beneficiary.vouchers }}
            </td>
            <td valign="middle" class="priority-3" v-if="orderType === 'PAPER'">
              <div>
                {{ beneficiary.nominal_value | toCurrency }}
              </div>
            </td>
            <td valign="middle" class="priority-3" v-if="orderType === 'PAPER'">
              {{ beneficiary.vouchers1 }}
            </td>
            <td valign="middle" class="priority-3" v-if="orderType === 'PAPER'">
              <div>
                {{ beneficiary.nominal_value1 | toCurrency }}
              </div>
            </td>
            <td valign="middle" class="priority-4" v-if="orderType === 'PAPER'">
              {{ beneficiary.vouchers2 }}
            </td>
            <td valign="middle" class="priority-4" v-if="orderType === 'PAPER'">
              <div>
                {{ beneficiary.nominal_value2 | toCurrency }}
              </div>
            </td>
          </tr>
          <tr :key="index + beneficiaries.length" class="child" :class="index % 2 === 0 && 'gri-cell'"
            v-show="detailsMobile && beneficiary === beneficiarySelectedMobile">
            <td colspan="12">
              <p class="priority-show-2" v-if="orderType !== 'PAPER'">
                <strong>{{ $t("beneficiariesTableSurname") }} &nbsp;&nbsp;</strong>
                <span>{{ beneficiary.last_name }}</span>
              </p>
              <p class="priority-show-3" v-if="orderType !== 'PAPER'">
                <strong>{{ $t("beneficiariesTableCNP") }} &nbsp;&nbsp;</strong>
                <span>{{ beneficiary.from_source_id }}</span>
              </p>
              <p class="priority-show-4" v-if="orderType !== 'PAPER'">
                <strong>{{
                  $t("beneficiariesTableTicketValue")
                }}
                  &nbsp;&nbsp;</strong>
                <span>
                  {{ beneficiary.total_nominal_value | toCurrency }}
                </span>
              </p>
              <p class="priority-show-2" v-if="orderType === 'PAPER'">
                <strong>{{ $t("noOfBookletLabel") }} &nbsp;&nbsp;</strong>
                <span>{{ beneficiary.booklets }}</span>
              </p>
              <p class="priority-show-2" v-if="orderType === 'PAPER'">
                <strong>{{ $t("noTicketsValue1Label1") }} &nbsp;&nbsp;</strong>
                <span>{{ beneficiary.vouchers }}</span>
              </p>
              <p class="priority-show-2" v-if="orderType === 'PAPER'">
                <strong>{{ $t("amountVoucher1Label1") }} &nbsp;&nbsp;</strong>
                <span>
                  {{ beneficiary.nominal_value | toCurrency }}
                </span>
              </p>
              <p class="priority-show-3" v-if="orderType === 'PAPER'">
                <strong>{{ $t("noTicketsValue2Label") }} &nbsp;&nbsp;</strong>
                <span>{{ beneficiary.vouchers1 }}</span>
              </p>
              <p class="priority-show-3" v-if="orderType === 'PAPER'">
                <strong>{{ $t("amountVoucher2Label") }} &nbsp;&nbsp;</strong>
                <span>
                  {{ beneficiary.nominal_value1 | toCurrency }}
                </span>
              </p>
              <p class="priority-show-4" v-if="orderType === 'PAPER'">
                <strong>{{ $t("noTicketsValue3Label") }} &nbsp;&nbsp;</strong>
                <span>{{ beneficiary.vouchers2 }}</span>
              </p>
              <p class="priority-show-4" v-if="orderType === 'PAPER'">
                <strong>{{ $t("amountVoucher3Label") }} &nbsp;&nbsp;</strong>
                <span>
                  {{ beneficiary.nominal_value2 | toCurrency }}
                </span>
              </p>
            </td>
          </tr>
        </template>
      </table>

      <div class="loading" v-if="this.beneficiaries === null">
        <img src="@/assets/images/loading.gif" />
      </div>
    </div>
  </div>
  <div
    v-else
    id="modal_popup_loading-beneficiary"
    class="modal-popup"
  >
    <div class="modal-popup-content">
      <img src="@/assets/images/loading.gif" />
      <!-- <p v-html="$t('loadingPopupMessage')">{{ $t('loadingPopupMessage') }}</p> -->
    </div>
  </div>
</template>

<script>
import utils from "@/plugins/utils.js";
import moment from "moment";
import Cookies from "js-cookie";
import httpServiceCustomer from "@/http/http-customer.js";
import OrderDetailsSummary from "@/components/company/customer/OrderDetailsSummary.vue";
import { saveAs } from "file-saver";
import products from "@/assets/json/products.js";

export default {
  props: {
    orderId: String,
    customer: Object,
    orderType: String,
    msg: String,
    deliveryAddresses: Array,
    simulation: Boolean
  },
  components: {
    OrderDetailsSummary,
  },
  data() {
    return {
      beneficiaries: null,
      order: null,
      orderError: null,
      openDetails: false,
      search: "",
      sortBy: "first_name",
      reverse: false,
      detailsMobile: false,
      beneficiarySelectedMobile: null,
    };
  },
  methods: {
    getCustomerOrderHeader() {
      httpServiceCustomer.customerService
        .getOrderHeader(
          this.orderId,
          this.customer.company_id,
          Cookies.get("token"),
          this.orderType,
          this.simulation
        )
        .then(function (response) {
          // handle success
          return response;
        })
        .catch(function () {
          // handle success
        })
        .then((response) => {
          if (response.status == 200) {
            this.order = response.data;
            // this.getCustomerOrderDetails();
          } else if (response.status == 400 || response.status == 403) {
            this.orderError = {
              code: response.data,
              description: "Error fetching order details",
            };
            // return null;
          } else {
            this.orderError = { description: response.description };
            // return null;
          }
        });
    },
    downloadExcelOrderFile() {
      httpServiceCustomer.customerService
        .getOrderModelFile(
          this.customer.company_id,
          this.orderId,
          this.orderType,
          Cookies.get("token")
        )
        .then(function (response) {
          // handle success
          return response;
        })
        .then((response) => {
          if (response.status == 200) {
            var blob = new Blob(
              [this.base64ToArrayBuffer(response.data.content)],
              {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetapplication/vnd.ms-excel",
              }
            );
            saveAs(blob, response.data.name);
            // download content
          }
        });
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    getCustomerOrderDetails() {
      // let searchParams = "?per_page=10000&page=1";
      httpServiceCustomer.customerService
        .getOrderDetails(
          this.orderId,
          this.customer.company_id,
          Cookies.get("token"),
          this.orderType,
          // searchParams,
          this.simulation
        )
        .then(function (response) {
          // handle success
          return response;
        })
        .catch(function () {
          // handle success
        })
        .then((response) => {
          if (response.status == 200) {
            this.beneficiaries = response.data;
            this.openDetails = true;
          } else if (response.status == 400 || response.status == 403) {
            this.orderError = {
              code: response.data,
              description: "Error fetching details for order " + this.orderId,
            };
            // return null;
          } else {
            this.orderError = { description: response.description };
            // return null;
          }
          this.showModalPopup("modal_popup_loading", false);
        });
    },
    getAddressDisplayName(addressCode) {
      for (let index in this.deliveryAddresses) {
        if (this.deliveryAddresses[index].codcom === addressCode) {
          return (
            this.deliveryAddresses[index].codcom +
            " - " +
            this.deliveryAddresses[index].address.street_name +
            ", " +
            this.deliveryAddresses[index].address.locality
          );
        }
      }
      return addressCode;
    },
    showModalPopup(elementId, show) {
      if (show) {
        document.getElementById(elementId).style.visibility = "visible";
      } else {
        document.getElementById(elementId).style.visibility = "hidden";
      }
    },
    selectBeneficiaryMobile(index) {
      this.beneficiarySelectedMobile = this.filterBeneficiaries[index];
      this.detailsMobile = !this.detailsMobile;
    },
    payOrder(later) {
      this.$emit("click", this.order, "pay" + later);
    },
    changeReverse() {
      this.reverse = !this.reverse;
    },
    selectColorStatus(status) {
      return utils.selectColorStatus(status);
    },
    getProductNameMethod(product, brand) {
      return utils.getProductByIdAndBrand(product, brand, products).name;
    },
    getDisplayDate(date) {
      return moment(new Date(date), "YYYY-MM-DDThh:mm:ss").format("DD/MM/YYYY");
    },

  },
  computed: {
    filterBeneficiaries: function () {
      if (this.beneficiaries && this.orderType !== "PAPER") {
        const result = this.beneficiaries
          .filter(
            (x) =>
              x.last_name.indexOf(this.search.toUpperCase()) > -1 ||
              x.first_name.indexOf(this.search.toUpperCase()) > -1 ||
              x.from_source_id.indexOf(this.search.toUpperCase()) > -1
          )
          .sort((a, b) =>
            a[this.sortBy] < b[this.sortBy]
              ? -1
              : a[this.sortBy] !== b[this.sortBy]
          );
        return this.reverse ? result.reverse() : result;
      } else {
        return this.beneficiaries;
      }
    },
    orderAddresses: function () {
      let addresses = [];
      for (let index in this.beneficiaries) {
        let address = this.getAddressDisplayName(this.beneficiaries[index].address);
        if (this.beneficiaries[index].address && !addresses.includes(address)) {
          addresses.push(address);
        }
      }
      return addresses;
    },

    excelFields: function () {
      if (this.orderType === "PAPER") {
        return {
          Beneficiary: "first_name",
          NoOfTichets1: "vouchers",
          Amount1: "nominal_value",
          NoOfTichets2: "vouchers1",
          Amount2: "nominal_value1",
          NoOfTichets3: "vouchers2",
          Amount3: "nominal_value2",
        };
      } else {
        return {
          Name: "first_name",
          Surname: "last_name",
          Employee_ID: "from_source_id",
          Amount: "total_nominal_value",
        };
      }
    },
    isOrderProductReward() {
      return this.order.brand === "rewards";
    },
  },

  mounted() {
    this.getCustomerOrderHeader();
    this.getCustomerOrderDetails();
  },
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
<style>
.padding-10 {
  padding: 10px !important;
}

.track-trace-big {
  height: 45px;
}
</style>
